import parse from './dealParse?asis';

let browser;
if (process.env.APP_TARGET == 'extension')
  browser = require('webextension-polyfill');

//mirrors ~target/extension/getMeta: inject the extractor into the active
//tab, degrade to link-only when scripting is unavailable/denied
export async function getDeal(tab) {
  let link = null;
  let tabId = null;
  try {
    const [active] = tab
      ? [tab]
      : await browser.tabs.query({ active: true, currentWindow: true });
    if (!active?.url) return null;
    tabId = active.id;
    link = { url: active.url, title: active.title, isDeal: false };
  } catch (e) {
    return null;
  }

  try {
    if (browser.scripting && tabId != null) {
      const [res] = await browser.scripting.executeScript({
        target: { tabId },
        files: [parse],
        injectImmediately: true,
      });
      if (res?.result?.url) return res.result;
    }
  } catch (e) {}

  return link;
}
